/* eslint-disable */

import { APIClient } from "./_api";
const endpoint = "/Discount";

export function getAll(query) {
  return APIClient.post(`${endpoint}/filter`, query);
}

export function getAllOwner(query) {
  return APIClient.post(`${endpoint}/owner`, query);
}

export function getAllCustom(query) {
  return APIClient.post(`${endpoint}/custom`, query);
}

export function getAllAgent(query) {
  return APIClient.post(`${endpoint}/agent`, query);
}

export function getOne() {
  return APIClient.get(`${endpoint}`);
}

export function remove(id) {
  return APIClient.delete(`${endpoint}/${id}`);
}

export function create(value) {
  return APIClient.post(`${endpoint}`, value);
}

export function applyDiscount(value) {
  return APIClient.post(`${endpoint}/apply`, value);
}

export function editDiscount(values) {
  return APIClient.put(`${endpoint}/${values.id}`, values.data);
}

export function getAllDiscountType(value) {
  return APIClient.get(`${endpoint}/type`, value);
}
